import { render, staticRenderFns } from "./Productsheadone.vue?vue&type=template&id=cb614440&"
import script from "./Productsheadone.vue?vue&type=script&lang=js&"
export * from "./Productsheadone.vue?vue&type=script&lang=js&"
import style0 from "./Productsheadone.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports